<ng-template [vbCssRules]="themeStyles | async"></ng-template>

<banner-renderer [name]="fullName" [banner]="webcast.producerOptions.banner" [webcast]="webcast">
</banner-renderer>

<producer-setup *ngIf="!ready; else backstageView" [webcast]="webcast" (onStreamsChanged)="updateStreams($event)" (goBackstage)="goBackstage()"></producer-setup>

<ng-template #backstageView>
	<backstage-view [webcast]="webcast" [producerOptions]="webcast.producerOptions"></backstage-view>
</ng-template>
